import React from "react"

import { useLenderApplicationsList } from "@boundless/bl-api-client/lender/services"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { RefreshCwIcon } from "lucide-react"

import {
  ApplicationsTable,
  FallbackApplicationsTable,
} from "@/components/applications/lender/ApplicationsTable"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { cn } from "@/lib/utils"

export const Route = createFileRoute("/_dashboard/lender/applications/list")({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["applications.view_application"])) {
      throw redirect({ to: "/" })
    }
  },
})

function RouteComponent() {
  const { refetch, isFetching } = useLenderApplicationsList()
  return (
    <Card>
      <CardHeader className="flex flex-row justify-between">
        <CardTitle>Applications</CardTitle>
        <Button
          className="h-8 min-w-8"
          onClick={() => refetch()}
          disabled={isFetching}
        >
          <RefreshCwIcon className={cn(isFetching && "animate-spin")} />
        </Button>
      </CardHeader>
      <CardContent>
        <React.Suspense fallback={<FallbackApplicationsTable />}>
          <ApplicationsTable />
        </React.Suspense>
      </CardContent>
    </Card>
  )
}
